/**
 * @generated SignedSource<<b6c351a71bf6ed8c63e67c47a9911924>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BulkInviteQuery$variables = {
  orgRelayId: string;
  queryInput: string;
};
export type BulkInviteQuery$data = {
  readonly org: {
    readonly id?: string;
    readonly billingGroups?: {
      readonly message?: string | null;
      readonly statusCode?: number | null;
      readonly " $fragmentSpreads": FragmentRefs<"BulkInvite_billingGroups">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"BulkInvite_org">;
  } | null;
};
export type BulkInviteQuery = {
  variables: BulkInviteQuery$variables;
  response: BulkInviteQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgRelayId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "queryInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orgRelayId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusCode",
      "storageKey": null
    }
  ],
  "type": "GraphEntityError",
  "abstractKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BulkInviteQuery",
    "selections": [
      {
        "alias": "org",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "queryInput",
                    "variableName": "queryInput"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "BulkInvite_org"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "billingGroups",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BulkInvite_billingGroups"
                      }
                    ],
                    "type": "BillingGroupList",
                    "abstractKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BulkInviteQuery",
    "selections": [
      {
        "alias": "org",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "excludeNonUsers",
                    "value": false
                  },
                  {
                    "kind": "Literal",
                    "name": "freePersonsOnly",
                    "value": true
                  },
                  {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 20
                  },
                  {
                    "kind": "Variable",
                    "name": "searchQuery",
                    "variableName": "queryInput"
                  },
                  {
                    "kind": "Literal",
                    "name": "sortDirection",
                    "value": "Ascending"
                  },
                  {
                    "kind": "Literal",
                    "name": "sortType",
                    "value": "FullName"
                  }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "orgPersonListPaginatedErrorable",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrgPerson",
                        "kind": "LinkedField",
                        "name": "persons",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "personId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "primaryCalendarId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "userId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserProfile",
                            "kind": "LinkedField",
                            "name": "profile",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "givenName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "familyName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "externalImageUrl",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "OrgPersonListPaginated",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "billingGroups",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BillingGroup",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "invitePolicy",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "adminOrgPersons",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrgPerson",
                                    "kind": "LinkedField",
                                    "name": "list",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isYou",
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "OrgPersonList",
                                "abstractKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "BillingGroupList",
                    "abstractKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "549a84468b33b9b50fc767d254b927a1",
    "id": null,
    "metadata": {},
    "name": "BulkInviteQuery",
    "operationKind": "query",
    "text": "query BulkInviteQuery(\n  $orgRelayId: ID!\n  $queryInput: String!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      id\n      ...BulkInvite_org_15N4cS\n      billingGroups {\n        __typename\n        ... on BillingGroupList {\n          ...BulkInvite_billingGroups\n        }\n        ... on GraphEntityError {\n          message\n          statusCode\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment BulkInvite_billingGroups on BillingGroupList {\n  list {\n    id\n    name\n    invitePolicy\n    adminOrgPersons {\n      __typename\n      ... on OrgPersonList {\n        list {\n          isYou\n          id\n        }\n      }\n      ... on GraphEntityError {\n        message\n        statusCode\n      }\n    }\n  }\n}\n\nfragment BulkInvite_org_15N4cS on Org {\n  id\n  orgPersonListPaginatedErrorable(sortType: FullName, sortDirection: Ascending, searchQuery: $queryInput, limit: 20, excludeNonUsers: false, freePersonsOnly: true) {\n    __typename\n    ... on OrgPersonListPaginated {\n      persons {\n        personId\n        primaryCalendarId\n        userId\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "51c0b1790ab1b40e632f6c59abeefb35";

export default node;
